import { ModuleWithProviders, NgModule } from '@angular/core';
import { BaiduMapController } from './baidu-map';
import { BaiduMap } from './baidu-map-component';

export { BaiduMapController } from './baidu-map';
export {
  MarkerSize,
  MarkerInfoWindow,
  MarkerOptions,
  PointCollectionOptions,
  MassOptions,
  BaiduMapOptions
} from './baidu-map-options';


export class BaiduMapModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: BaiduMapModule,
      providers: [
        BaiduMapController
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [
    BaiduMap
  ],
  declarations: [
    BaiduMap
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
